
import { Path } from '@/main/router/routerPath';

import List from './List.vue';
import { NAME } from './constants';
import Edit from './Edit.vue';

export const router = new Path(NAME, { List, Edit }, 'Customer_Leads');
